import { render, staticRenderFns } from "./addPatchDialog.vue?vue&type=template&id=657932f9&"
import script from "./addPatchDialog.vue?vue&type=script&lang=js&"
export * from "./addPatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports